// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as React from "react";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as DomUtils from "../../utils/DomUtils.bs.jsx";
import * as UserRoles from "../../backend/UserRoles.bs.jsx";
import * as Reactfire from "reactfire";
import * as ChangeRole from "./ChangeRole.bs.jsx";
import * as RouterUtils from "../../utils/RouterUtils.bs.jsx";
import * as PersonRename from "./PersonRename.bs.jsx";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as DialogCycling from "../../components/DialogCycling/DialogCycling.bs.jsx";
import * as LoadingInline from "../../components/LoadingInline/LoadingInline.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as SendInvitation from "./SendInvitation.bs.jsx";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as FormattedCurrency from "../../components/FormattedCurrency/FormattedCurrency.bs.jsx";
import * as FormattedDateTime from "../../components/FormattedDataTime/FormattedDateTime.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as DialogConfirmation from "../../components/DialogConfirmation/DialogConfirmation.bs.jsx";
import * as Firestore from "firebase/firestore";
import * as AddFinancialTransactions from "./AddFinancialTransactions.bs.jsx";
import PersonDetailModuleCss from "./PersonDetail.module.css";

let classes = PersonDetailModuleCss;

function byCreatedDesc(a, b) {
  return b.createdAt.toMillis() - a.createdAt.toMillis();
}

function PersonDetail(props) {
  let placeId = props.placeId;
  let place = props.place;
  let personId = props.personId;
  let personsAll = props.personsAll;
  let person = props.person;
  let pendingTransactions = props.pendingTransactions;
  let onDeletePerson = props.onDeletePerson;
  let firestore = Reactfire.useFirestore();
  let match = Db.usePlacePersonDocumentStatus({
    idField: "uid",
    suspense: false
  }, placeId, personId);
  let maybePersonDoc = match.data;
  let match$1 = React.useState(() => "Hidden");
  let setDialog = match$1[1];
  let dialogState = match$1[0];
  let hideDialog = param => setDialog(param => "Hidden");
  let personsAllDict = React.useMemo(() => Object.fromEntries(personsAll), [personsAll]);
  let personRole = Stdlib_Option.flatMap(Stdlib_Option.flatMap(Primitive_option.fromNull(person.userId), userId => place.accounts[userId]), param => UserRoles.roleFromInt(param[0]));
  let tmp;
  if (personRole !== undefined) {
    let tmp$1;
    tmp$1 = personRole === 100 ? null : <>
        {` (`}
        <button
          className={Styles.link.base}
          type={"button"}
          onClick={param => setDialog(param => ({
            TAG: "ChangeRole",
            _0: personRole
          }))}
        >
          {`změnit oprávnění`}
        </button>
        {`)`}
      </>;
    tmp = <p
      className={Styles.messageBar.base}
    >
      {`Má propojený účet a oprávnění jako `}
      <b>
        {UserRoles.roleI18n(personRole)}
      </b>
      {tmp$1}
    </p>;
  } else {
    tmp = <p
      className={Styles.messageBar.base}
    >
      {`Nemá propojený účet. `}
      <button
        className={Styles.link.base}
        type={"button"}
        onClick={param => setDialog(param => "SendInvitation")}
      >
        {`Poslat pozvánku`}
      </button>
    </p>;
  }
  let tmp$2;
  let exit = 0;
  if (maybePersonDoc !== undefined) {
    if (pendingTransactions.length !== 0 || maybePersonDoc.transactions.length !== 0) {
      exit = 1;
    } else {
      tmp$2 = <p>
        {"Tato osoba zatím nemá účetní záznamy."}
      </p>;
    }
  } else {
    tmp$2 = <LoadingInline.make />;
  }
  if (exit === 1) {
    let transactions = maybePersonDoc.transactions;
    pendingTransactions.sort(byCreatedDesc);
    transactions.sort(byCreatedDesc);
    tmp$2 = <table
      aria-labelledby={"financial_transactions"}
      className={classes.tableTransactions + ` ` + Styles.table.inDialog}
    >
      <thead>
        <tr>
          <th
            scope={"col"}
          >
            {"Datum"}
          </th>
          <th
            scope={"col"}
          >
            {"Částka"}
          </th>
          <th
            scope={"col"}
          >
            {"Poznámka"}
          </th>
        </tr>
      </thead>
      <tbody>
        {pendingTransactions.map(pendingTransaction => {
          let createdDate = pendingTransaction.createdAt.toDate();
          let kegSerial = pendingTransaction.keg;
          return <tr
            key={createdDate.getTime().toString()} 
            className={classes.unclosed}
          >
            <td>
              <FormattedDateTime.make
                value={createdDate}
              />
            </td>
            <td>
              <FormattedCurrency.make
                value={pendingTransaction.amount}
              />
            </td>
            <td>
              {kegSerial !== null ? `Nezaúčtované: vklad za sud ` + Db.formatKegSerial(kegSerial) : null}
            </td>
          </tr>;
        })}
        {transactions.map(finalTransaction => {
          let createdDate = finalTransaction.createdAt.toDate();
          let match = finalTransaction.keg;
          let match$1 = finalTransaction.note;
          let match$2 = finalTransaction.person;
          let match$3 = finalTransaction.amount > 0;
          return <tr
            key={createdDate.getTime().toString()} >
            <td>
              <FormattedDateTime.make
                value={createdDate}
              />
            </td>
            <td>
              <FormattedCurrency.make
                value={finalTransaction.amount}
              />
            </td>
            <td>
              {match$1 !== null ? match$1 : (
                  match !== null ? (
                      match$3 ? `Vklad sudu ` + Db.formatKegSerial(match) : `Konzumace ze sudu ` + Db.formatKegSerial(match)
                    ) : (
                      match$2 !== null ? (
                          match$3 ? `Převod pro ` + personsAllDict[match$2].name : `Převod od ` + personsAllDict[match$2].name
                        ) : null
                    )
                )}
            </td>
          </tr>;
        })}
      </tbody>
    </table>;
  }
  let tmp$3;
  if (typeof dialogState !== "object") {
    switch (dialogState) {
      case "Hidden" :
        tmp$3 = null;
        break;
      case "AddTransaction" :
        let highestBalanceNonCurrentPerson = Stdlib_Array.reduce(personsAll, undefined, (acc, item) => {
          if (item[0] === personId || acc !== undefined && acc[1].balance >= item[1].balance) {
            return acc;
          } else {
            return item;
          }
        });
        tmp$3 = <AddFinancialTransactions.make
          initialCounterParty={Stdlib_Option.getOr(Stdlib_Option.map(highestBalanceNonCurrentPerson, prim => prim[0]), "")}
          onDismiss={hideDialog}
          onSubmit={values => {
            Db.Person.addFinancialTransaction(firestore, placeId, personId, values.person, {
              amount: values.amount,
              createdAt: Firestore.Timestamp.now(),
              keg: null,
              note: values.note === "" ? null : values.note,
              person: values.person
            });
            setDialog(param => "Hidden");
          }}
          personId={personId}
          personName={person.name}
          personsAll={personsAll}
        />;
        break;
      case "ConfirmDeletePerson" :
        tmp$3 = <DialogConfirmation.make
          className={DialogConfirmation.classes.deleteConfirmation}
          heading={"Odstranit osobu ?"}
          onConfirm={() => {
            setDialog(param => "Hidden");
            onDeletePerson();
          }}
          onDismiss={hideDialog}
          visible={true}
        >
          <p>
            {`Chystáte se odstranit osobu `}
            <b>
              {person.name}
            </b>
            {` z aplikace. Nemá žádnou historii konzumací ani účetní transakci. Chcete pokračovat?`}
          </p>
        </DialogConfirmation.make>;
        break;
      case "Rename" :
        tmp$3 = <PersonRename.make
          existingNames={Stdlib_Array.filterMap(personsAll, param => {
            if (param[0] === personId) {
              return;
            } else {
              return param[1].name;
            }
          })}
          initialName={person.name}
          onDismiss={hideDialog}
          onSubmit={param => {
            let name = param.name;
            if (name !== person.name) {
              Db.PersonsIndex.update(firestore, placeId, [[
                  personId,
                  {
                    balance: person.balance,
                    name: name,
                    preferredTap: person.preferredTap,
                    recentActivityAt: person.recentActivityAt,
                    userId: person.userId
                  }
                ]]);
            }
            setDialog(param => "Hidden");
          }}
        />;
        break;
      case "SendInvitation" :
        tmp$3 = <SendInvitation.make
          onDismiss={hideDialog}
          onSubmit={async values => {
            let linkId = await Db.ShareLink.upsert(firestore, placeId, personId, values.role);
            let url = RouterUtils.createShareLink(linkId);
            let handler = await DomUtils.share({
              text: `Zvu tě do aplikace check.beer, kde uvidíš svůj pivní lístek.`,
              title: `Pozvánka do aplikace check.beer`,
              url: url
            });
            if (handler !== "Clipboard") {
              return;
            }
            window.alert("Pozvánka byla zkopírována do schránky.");
          }}
        />;
        break;
    }
  } else {
    tmp$3 = <ChangeRole.make
      currentRole={dialogState._0}
      onDismiss={hideDialog}
      onSubmit={param => {
        Db.Place.changePersonRole(firestore, placeId, personId, param.role);
        setDialog(param => "Hidden");
      }}
      personName={person.name}
    />;
  }
  return <>
    <DialogCycling.make
      className={classes.root}
      hasNext={props.hasNext}
      hasPrevious={props.hasPrevious}
      header={person.name}
      headerSlot={props.canRename ? <button
          className={Styles.button.iconOnly}
          title={"Přejmenovat"}
          type={"button"}
          onClick={param => setDialog(param => "Rename")}
        >
          {"✏️"}
        </button> : undefined}
      onDismiss={props.onDismiss}
      onNext={props.onNextPerson}
      onPrevious={props.onPreviousPerson}
      visible={true}
    >
      <section
        aria-label={"Základní údaje"}
      >
        <dl
          className={Styles.descriptionList.inline}
        >
          <div>
            <dt>
              {"již od"}
            </dt>
            <dd>
              {maybePersonDoc !== undefined ? <FormattedDateTime.make
                  value={maybePersonDoc.createdAt.toDate()}
                /> : <LoadingInline.make />}
            </dd>
          </div>
          <div>
            <dt>
              {"naposledy"}
            </dt>
            <dd>
              <FormattedDateTime.make
                value={person.recentActivityAt.toDate()}
              />
            </dd>
          </div>
          <div>
            <dt>
              {"stav konta"}
            </dt>
            <dd>
              <FormattedCurrency.make
                value={person.balance}
                format={FormattedCurrency.formatAccounting}
              />
            </dd>
          </div>
        </dl>
      </section>
      {tmp}
      {props.unfinishedConsumptions.length !== 0 || pendingTransactions.length !== 0 || maybePersonDoc === undefined || maybePersonDoc.transactions.length !== 0 ? null : <p>
          {person.name + ` nemá nezaúčtovaná piva. Dokonce nemá ani účetní záznam. Pokud jste tuto osobu přidali omylem, můžete jí nyní `}
          <button
            className={Styles.link.base}
            type={"button"}
            onClick={param => setDialog(param => "ConfirmDeletePerson")}
          >
            {"zcela odebrat z aplikace"}
          </button>
          {". S účetním záznamem to později již není možné ☝️"}
        </p>}
      <section
        aria-labelledby={"financial_transactions"}
      >
        <header>
          <h3
            id={"financial_transactions"}
          >
            {"Účetní záznamy"}
          </h3>
          {React.cloneElement(<button
            className={Styles.button.base}
            type={"button"}
            onClick={param => setDialog(param => "AddTransaction")}
          >
            {"Nová platba"}
          </button>, personsAll.length < 2 ? ({
              disabled: true,
              title: "Přidejte další osoby"
            }) : ({}))}
        </header>
        {tmp$2}
      </section>
    </DialogCycling.make>
    {tmp$3}
  </>;
}

let make = PersonDetail;

export {
  classes,
  byCreatedDesc,
  make,
}
/* classes Not a pure module */
